import { Schema, type } from "@colyseus/schema"
import { defaultCardSrc as defaultSource } from "../../consts"

export const cardColorsCommon = ["red", "yellow", "green", "blue"] as const
export type CardColorsCommon = (typeof cardColorsCommon)[number]
export const cardColorBlack = "black"
export const cardColorArray = [...cardColorsCommon, cardColorBlack] as const
export type CardColors = (typeof cardColorArray)[number]

export const cardType0 = "0"
export const cardTypeDefault = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
] as const
export const cardTypeSpecial = ["block", "reverse", "take-2"] as const
export const cardTypeBlack = ["change-color", "take-4"] as const
export const cardTypeArray = [
  cardType0,
  ...cardTypeDefault,
  ...cardTypeSpecial,
  ...cardTypeBlack,
] as const
export type CardTypes = (typeof cardTypeArray)[number]

export class CardDataClass extends Schema {
  @type("string") cardColor: CardColors
  @type("string") cardType: CardTypes
  @type("string") custom: string

  constructor(
    cardColor: CardColors,
    cardType: CardTypes,
    custom = defaultSource
  ) {
    super()

    this.cardColor = cardColor
    this.cardType = cardType
    this.custom = custom
  }
}

export type CardData = InstanceType<typeof CardDataClass>
